import React from 'react';
import { Select } from 'antd';
import FormItem from '../FormItem/FormItem';
import { formConfig } from '../../../../config';
import { useWarrantyDocTypes } from '../../../../api/queries/useWarrantyDocTypes';
import { dspxGetChildrens } from '../../../../../../../../helpers/dspx-utils';

const { fieldNames } = formConfig;
const typeFieldName = fieldNames.docType;
const nameFieldName = fieldNames.docName;

const SelectDocTypeField = ({ form, required }) => {
  const { data, isFetching } = useWarrantyDocTypes({ staleTime: Infinity });

  const handleChange = (value) => {
    if (!value || form.getFieldValue(nameFieldName)) return;

    const docType = data?.find((item) => item.id === Number(value));

    if (docType) {
      form.setFieldsValue({ [nameFieldName]: docType.name });
    }
  };

  return (
    <FormItem label="Тип документа">
      {form.getFieldDecorator(typeFieldName, {
        rules: [
          {
            required,
            message: 'Укажите тип документа',
          },
        ],
      })(
        <Select
          showSearch
          placeholder="Выберите тип документов"
          optionFilterProp="searchtext"
          onChange={handleChange}
          loading={isFetching}
          optionLabelProp="label"
        >
          {dspxGetChildrens(data)}
        </Select>
      )}
    </FormItem>
  );
};

export default SelectDocTypeField;
